// extracted by mini-css-extract-plugin
export default {"card":"style_card__IHDaX","cardBig":"style_cardBig__0Y6Pj","count":"style_count__e2t00","smallCount":"style_smallCount__p5mNS","text":"style_text__KR8hT"};